import { useEffect, useState } from "react";
import { debounce } from "lodash";
import BreadCrumb from "../../common/breadCrumb/BreadCrumb";
import UKETSAerReport from "../../components/UKETSAnnualEmissionReport/UKETSAerReport";
import "./UKETSAerReportPage.scss";

const UKETSAerReportPage = () => {
	const [showBreadCrumb, setShowBreadCrumb] = useState(() => {
		const storedValue = sessionStorage.getItem("header-footer");
		return storedValue !== null ? JSON.parse(storedValue) : true;
	});

	const [activeTabLabel, setActiveTabLabel] = useState("Company Details");

	const debouncedSetBreadCrumb = debounce((value) => {
		setShowBreadCrumb(value);
	}, 100);

	useEffect(() => {
		const storedValue = sessionStorage.getItem("header-footer");
		if (storedValue !== null) {
			debouncedSetBreadCrumb(JSON.parse(storedValue));
		}
	}, [debouncedSetBreadCrumb]);

	const navigationItems = [
		{
			label: "Annual Emission Verification",
			url: "",
			navId: "annual_emission_verification_navid",
		},
		{
			label: "UK ETS Annual Emission Report",
			url: "/uk-ets-annual-emission-report",
			navId: "uketsaer_listing_navid",
		},
		{
			label: activeTabLabel,
			url: "",
			navId: "uketsaer_detail_navid",
		},
	];

	const handleTabChange = (tabLabel) => {
		setActiveTabLabel(tabLabel);
	};

	return (
		<div className="uketsaer-report-page p-4">
			{showBreadCrumb && <BreadCrumb items={navigationItems} />}
			<UKETSAerReport onTabChange={handleTabChange} />
		</div>
	);
};

export default UKETSAerReportPage;
